// src/auth/LoginView.js
import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import './Login.css';

/**
 * 表示パターン定義
 * - 必要に応じて増やしてください（キーが kind になります）
 */
const VARIANTS = {
  'reset-sent': {
    title: 'メールを送信しました',
    lines: [
      'パスワード再設定用のリンクをメールにて送信しました。',
      '再設定用リンクよりパスワードの更新をお願いします。',
    ],
    primary: { label: 'ログイン画面へ戻る', to: '/login' },
  },
  'reset-success': {
    title: 'パスワードを再設定しました',
    lines: [
      '新しいパスワードでログインできます。',
      'セキュリティのため、古いパスワードは無効になっています。',
    ],
    primary: { label: 'ログインへ進む', to: '/login' },
  },
  'signup-thanks': {
    title: 'ご登録ありがとうございます',
    lines: [
      'アカウントの作成が完了しました。',
      'ログイン画面からログインしてください。',
    ],
    primary: { label: 'ログインへ進む', to: '/login' },
  },
   'userinvite': {
    title: 'ご参加ありがとうございます',
    lines: [
      'ご招待アカウントのイベント情報に参加しました。',
      'ログイン画面よりログインいただき、ご確認ください。',
    ],
    primary: { label: 'ログインへ進む', to: '/login' },
  },
 'userinvite-already': {
    title: '参加済みです',
    lines: [
      'ご招待アカウントのイベント情報には参加済みです。',
      'ログイン画面よりログインいただき、ご確認ください。',
    ],
    primary: { label: 'ログインへ進む', to: '/login' },
  },
  'userinvite-error': {
  title: '招待の処理に失敗しました',
  lines: [
    '招待リンクが無効か期限切れの可能性があります。',
    '招待者に再度リンクの発行を依頼してください。',
  ],
  primary: { label: 'ログイン画面へ', to: '/login' },
},
};

/**
 * 使い方（いずれかで指定できます）:
 * - ルートパラメータ:   /auth/login-view/:kind         例) /auth/login-view/reset-sent
 * - クエリパラメータ:   /auth/login-view?kind=xxxx     例) /auth/login-view?kind=signup-thanks
 * - location.state.kind を渡す
 * さらに location.state で以下を上書き可能:
 *   - title, lines(Array<string>), primaryLabel, primaryTo
 *   - secondaryTo, secondaryLabel
 */
export default function LoginView({ defaultKind = 'reset-sent' }) {
  const { kind: paramKind } = useParams();
  const location = useLocation();

  const qs = new URLSearchParams(location.search);
  const qsKind = qs.get('kind');

  const state = location.state || {};
  const kind = state.kind || paramKind || qsKind || defaultKind;

  const base = VARIANTS[kind] || VARIANTS[defaultKind];

  const title = state.title || base.title;
  const lines = Array.isArray(state.lines) && state.lines.length > 0 ? state.lines : base.lines;

  const primary = {
    label: state.primaryLabel || base.primary.label,
    to: state.primaryTo || base.primary.to,
  };

  const secondary = state.secondaryTo
    ? { label: state.secondaryLabel || '戻る', to: state.secondaryTo }
    : null;

  return (
    <div className="login-container">
      <div className="login-card" role="alertdialog" aria-labelledby="authview-title">
        <h2 id="authview-title" className="login-title">{title}</h2>

        {lines.map((line, i) => (
          <p key={i} className="login-subtitle">{line}</p>
        ))}

        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <Link to={primary.to} >{primary.label}</Link>
        </div>

        {secondary && (
          <div className="link-row" style={{ marginTop: 10 }}>
            <Link to={secondary.to} className="link">{secondary.label}</Link>
          </div>
        )}
      </div>
    </div>
  );
}
